<template>
	<main class="">
		<projects type="list"></projects>
	</main>
</template>

<script>
// Import components
import projects from '/views/projects'

export default {
	name: 'projects-listing',
	components: {
    projects
  },
  head: {
    meta: function () {
      return [
        { name: 'description', content: 'Jun Ichiro Koyama\'s portfolio and blog' },
        { property: 'og:title', content: 'Jun Ichiro Koyama | @junichiroar' },
        { property: 'og:description', content: 'Jun Ichiro Koyama\'s portfolio and blog'},
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://junichirokoyama.com/' },
        { property: 'og:image', content: 'https://junichirokoyama.com/admin/wp-content/uploads/2021/01/og.png' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@junichiroar' }
      ]
    }
  }
}
</script>
